import actionTypes from './actionTypes';

const requestScreeners = () => ({
    type: actionTypes.REQUEST_SCREENERS,
});

const screenersResponse = (success, screeners = {}, errors) => ({
    type: actionTypes.SCREENERS_RESPONSE,
    payload: {
        success,
        screeners,
        errors
    }
});

const requestScreener = () => ({
    type: actionTypes.REQUEST_SCREENER,
});

const screenerResponse = (success, screener = {}, errors) => ({
    type: actionTypes.SCREENER_RESPONSE,
    payload: {
        success,
        screener,
        errors
    }
});

export default {
    requestScreeners,
    screenersResponse,
    requestScreener,
    screenerResponse
};